module.exports = __webpack_public_path__ + "static/media/jumpscare.a11ecaf8.mp3";